<template>
  <div id="app">
    <transition name="app-toast">
      <div v-if="activeToast" class="app-toast-wrap">
        <div class="app-toast" :class="`app-toast-${activeToast.type}`">
          <span class="app-toast-message">{{ activeToast.message }}</span>
          <button class="app-toast-close" type="button" @click="clearToast">x</button>
        </div>
      </div>
    </transition>
    <router-view />
  </div>
</template>

<script>
import toastService from './services/toastService';

export default {
  name: 'App',
  computed: {
    activeToast() {
      return toastService.state.current;
    },
  },
  methods: {
    clearToast() {
      toastService.clear();
    },
  },
};
</script>

<style>
body {
  font-family: Arial, sans-serif;
}

.app-toast-wrap {
  position: fixed;
  top: 18px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 3000;
  width: min(92vw, 720px);
  pointer-events: none;
}

.app-toast {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-radius: 14px;
  padding: 14px 16px;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.18);
  border: 1px solid transparent;
  backdrop-filter: blur(8px);
  pointer-events: auto;
}

.app-toast-message {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
}

.app-toast-close {
  border: none;
  background: transparent;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  color: inherit;
  opacity: 0.8;
}

.app-toast-info {
  background: rgba(239, 246, 255, 0.96);
  border-color: #93c5fd;
  color: #1d4ed8;
}

.app-toast-success {
  background: rgba(240, 253, 244, 0.97);
  border-color: #86efac;
  color: #166534;
}

.app-toast-warning {
  background: rgba(255, 251, 235, 0.97);
  border-color: #fcd34d;
  color: #a16207;
}

.app-toast-error {
  background: rgba(254, 242, 242, 0.97);
  border-color: #fca5a5;
  color: #b91c1c;
}

.app-toast-enter-active,
.app-toast-leave-active {
  transition: all 0.22s ease;
}

.app-toast-enter,
.app-toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -10px);
}
</style>
